import { HamsCart } from 'modules/cart/duck/model';
import { Selector } from 'model/State';

export const isCartAFreeOrder = (cart: HamsCart) => cart.items.length > 0 && cart.totalIncTax === 0;

const getIsFreeOrder: Selector<boolean> = (state) =>
  !!state.cart.payload.ifSuccess((cart) => cart && isCartAFreeOrder(cart));

export default getIsFreeOrder;
